var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('path',{attrs:{"d":"M6,13H18V11H6M3,6V8H21V6M10,18H14V16H10V18Z"}})}
var staticRenderFns = []

export { render, staticRenderFns }